var version = '6.4.3';

module.exports = version;
